import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import BookingForm from './components/BookingForm';
import VehiclesSection from './components/VehiclesSection';
import DestinationsSection from './components/DestinationsSection';
import ContactSection from './components/ContactSection';
import ReviewsSection from './components/ReviewsSection';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import PaymentPage from './components/PaymentPage';

const Home = () => {
  return (
    <div>
      <Header />
      <HeroSection />
      <AboutSection />
      <BookingForm />
      <VehiclesSection />
      <DestinationsSection />
      <ContactSection />
      <ReviewsSection />
      <Footer />
      <FloatingButtons />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/payment" element={<PaymentPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
